import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { LoggerService } from '../services/utils/logger.service';
import { inject } from '@angular/core';
import { httpErrorLogLevel } from '../handlers/http-error-log-level';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        !isFailedLoginAttempt(req.url, error.status)
      ) {
        logger.log('HTTP request failed', httpErrorLogLevel(error.status), {
          url: req.url,
          method: req.method,
          status: error.status,
          backendMessage: error.error?.message,
          traceId: req.headers.get('X-Bl-Trans-Id') || null,
        });
      }

      return throwError(() => error);
    })
  );
};

function isFailedLoginAttempt(url: string, status: number): boolean {
  return status === 401 && url.endsWith('/auth/login');
}
